import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=2a33f818&scoped=true&"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=2a33f818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33f818",
  null
  
)

export default component.exports